import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { ABOUT_US, AUTHENTICATION } from '../config/apiEndPoint';
import { POST } from 'config/api.config';

export const loginData = async (data) => {
    // console.log('data', data)
    try {
        const response = await POST(AUTHENTICATION.LOGIN_USER, data);
        // console.log('...response', response)
        return response;
    } catch (error) {
        toast.error(response.message);
    }
};

// export const forgotPassword = async (data = array()) => {
//     try {
//         const response = await POST(AUTHENTICATION.FORGOT_PASSWORD, data);
//         return response;
//     } catch (error) {
//         toast.error(response.message);
//     }
// };

// export const resetPassword = async (data = array()) => {
//     try {
//         const response = await POST(AUTHENTICATION.RESET_PASSWORD, data);
//         return response;
//     } catch (error) {
//         toast.error(response.message);
//     }
// };

// export const passwordRequest = async (data = array()) => {
//     try {
//         const response = await POST(AUTHENTICATION.PASSWORD_REQUEST, data);
//         return response;
//     } catch (error) {
//         toast.error(response.message);
//     }
// };